module.exports = __webpack_public_path__ + "img/arrow-return-right.0ec34153.svg";